// Mensajes del chat abierto: del espejo del VPS si responde (una descarga por
// chat y luego solo los cambios), y si no, de las páginas de Firestore de
// siempre (messagePages.ts).
//
// Con el espejo el chat llega entero, pero se enseña igual que antes: los
// últimos 50 y "cargar anteriores" de 50 en 50. Lo que llega nuevo se añade
// sin esconder nada de lo que ya se veía.
import { escucharMensajes } from "../../shared/vpsMirror";
import { listenMessagePages, MESSAGE_PAGE_SIZE, MessagePageState } from "./messagePages";
import { mensajesEnOrden } from "./lecturasWhatsapp";

export function listenMessages(db: any, threadId: string, emit: (s: MessagePageState) => void) {
  let paginas: ReturnType<typeof listenMessagePages> | null = null;
  let todas: any[] | null = null;
  let ocultas = -1;
  const pintar = () => {
    if (paginas) return;
    if (!todas) {
      emit({ messages: [], more: false, loading: true, error: false });
      return;
    }
    if (ocultas < 0) ocultas = Math.max(0, todas.length - MESSAGE_PAGE_SIZE);
    const desde = Math.min(ocultas, todas.length);
    emit({ messages: todas.slice(desde), more: desde > 0, loading: false, error: false });
  };
  const baja = escucharMensajes(threadId, (filas) => {
    todas = mensajesEnOrden(filas);
    pintar();
  }, () => {
    paginas = listenMessagePages(db, threadId, emit);
    return () => paginas?.close();
  });
  pintar();
  return {
    more() {
      if (paginas) { paginas.more(); return; }
      if (!todas || ocultas <= 0) return;
      ocultas = Math.max(0, ocultas - MESSAGE_PAGE_SIZE);
      pintar();
    },
    retry() { paginas?.retry(); },
    close() { baja(); },
  };
}
